import {
  textToPapiEditorText,
  convertToServerXhrPayload,
} from '@wix/da-shared-react/pkg/DaEditorWrapper/utils';
import { ModuleConfig } from '../../../../../types/modules';
import { FormValues } from '../types';

export const configAdapter = ({ config = {} }: ModuleConfig): FormValues => {
  const { title = '', tagline = '' } = config || {};
  let { description } = config || {};
  // Convert legacy writer format to draftjs
  if (description?.html?.type === 'writer') {
    description = textToPapiEditorText(description?.excerpt || '');
  }
  return {
    title,
    tagline,
    description,
  };
};

export const submitAdapter = (formValues: FormValues) => {
  const { title = '', tagline = '', description } = formValues;
  const { editorRaw } = convertToServerXhrPayload(
    description.rawContentState,
    description.editorContent,
    description.features
  );
  return {
    title,
    tagline,
    editorRaw,
  };
};
